import { Link } from "@tanstack/react-router";
import { formatearMoneda, type EstadoFactura } from "@uirtus/shared";
import { usePagos } from "../lib/pagos";
import { Boton } from "../componentes/ui";

const COLOR_ESTADO: Record<EstadoFactura, string> = {
  BORRADOR: "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300",
  PENDIENTE_TIMBRE: "bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-300",
  TIMBRADA: "bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300",
  ERROR_TIMBRE: "bg-red-100 text-red-800 dark:bg-red-950 dark:text-red-300",
  CANCELACION_SOLICITADA: "bg-orange-100 text-orange-800 dark:bg-orange-950 dark:text-orange-300",
  CANCELADA: "bg-slate-200 text-slate-600 dark:bg-slate-800 dark:text-slate-400",
};

export function Pagos() {
  const { data, isLoading } = usePagos();
  const pagos = data ?? [];

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-lg font-semibold">Pagos</h1>
        <Link to="/pagos/nuevo">
          <Boton>Registrar pago</Boton>
        </Link>
      </div>

      {isLoading ? (
        <p className="text-sm text-slate-500">Cargando…</p>
      ) : (
        <div className="overflow-x-auto rounded-lg border border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-900">
          <table className="w-full text-sm">
            <thead className="border-b border-slate-200 text-left text-xs uppercase text-slate-500 dark:border-slate-800">
              <tr>
                <th className="px-4 py-2">Fecha</th>
                <th className="px-4 py-2">Cliente</th>
                <th className="px-4 py-2">Facturas</th>
                <th className="px-4 py-2">Estado</th>
                <th className="px-4 py-2 text-right">Monto</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100 dark:divide-slate-800">
              {pagos.map((p) => (
                <tr key={p.id} className="cursor-default">
                  <td className="px-4 py-2">
                    <Link
                      to="/pagos/$id"
                      params={{ id: p.id }}
                      className="text-marca-600 hover:underline"
                    >
                      {new Date(p.fechaPago).toLocaleDateString("es-MX")}
                    </Link>
                  </td>
                  <td className="px-4 py-2">
                    <div>{p.cliente.razonSocial}</div>
                    <div className="font-mono text-xs text-slate-500">{p.cliente.rfc}</div>
                  </td>
                  <td className="px-4 py-2 font-mono text-xs">
                    {p.documentos.length === 0
                      ? "—"
                      : p.documentos.length === 1
                        ? "1 factura"
                        : `${p.documentos.length} facturas`}
                  </td>
                  <td className="px-4 py-2">
                    {p.facturaPago && (
                      <span
                        className={`rounded-full px-2 py-0.5 text-xs font-medium ${COLOR_ESTADO[p.facturaPago.estado]}`}
                      >
                        {p.facturaPago.estado.replace(/_/g, " ").toLowerCase()}
                      </span>
                    )}
                  </td>
                  <td className="px-4 py-2 text-right font-mono">
                    {formatearMoneda(p.monto, p.moneda)}
                  </td>
                </tr>
              ))}
              {pagos.length === 0 && (
                <tr>
                  <td colSpan={5} className="px-4 py-8 text-center text-slate-500">
                    Todavía no hay pagos registrados.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
